import React, { useEffect, useState } from "react";
import { Button, Dropdown, Form, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import api from "../../../../services/api";
import PageHeader from "../../../components/Pageheader";

function Funcionarios(props) {
  const history = useHistory();
  const [funcionarios, setFuncionarios] = useState(null);
  const [idPessoa, setIdPessoa] = useState("");
  const [loading, setLoading] = useState(true);
  const [showInativos, setShowInativos] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [pesquisar, setPesquisar] = useState("")

  useEffect(() => {
    obterFuncionarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function obterFuncionarios() {
    setLoading(true);
    api
      .get(`funcionarios`)
      .then((res) => {
        const { funcionarios } = res.data;
        console.log(funcionarios);
        setFuncionarios(funcionarios);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }

  function handleModal(idFuncionario) {
    setIdPessoa(idFuncionario);
    setShowModal(true);
  }

  function handleCloseModal() {
    setIdPessoa("");
    setShowModal(false);
  }

  async function handleApagarFuncionario() {
    console.log(idPessoa);
    api
      .delete(`funcionarios/${idPessoa}`)
      .then((res) => {
        console.log(res.data);
        handleCloseModal();
        obterFuncionarios();
      })
      .catch((err) => {
        console.error(err);
        handleCloseModal();
      });
  }
  return (
    <div>
      {
        <PageHeader
          titulo="Cadastro de Funcionários"
          hasButton={true}
          buttonText="Adicionar novo Funcionário"
          pageName="/dashboard/cadastro/funcionario/adicionar"
        />
      }

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {/* <p className="card-description"> Add className <code>.table-striped</code> </p>*/}
              {loading ? (
                <h4 className="card-title">Carregando</h4>
              ) : funcionarios ? (
                <div className="table-responsive">
                  <div className="row">
                  <div className="col-md-5">
                   
                    <Form.Group>
                      <Form.Control
                      type="text"
                      placeholder="Pesquisar"
                      onChange={(e) => setPesquisar(e.target.value)}
                      />
                    </Form.Group>
                  </div>
                  <div className="col ">
                    <div className="form-check ">
                      <label className="form-check-label text-muted">
                        <input
                          value={showInativos}
                          onChange={(e) => setShowInativos(e.target.checked)}
                          name="checkAll"
                          type="checkbox"
                          className="form-check-input"
                        />
                        <i className="input-helper"></i>
                        Exibir Inativos
                      </label>
                    </div>
                  </div>
                  </div>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Matrícula</th>
                        <th scope="col">PIS</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Unidade</th>
                        <th scope="col">Setor</th>
                        {/*<th scope="col">Cargo</th>*/}
                        <th scope="col">Status</th>
                        <th scope="col">Opção</th>
                      </tr>
                    </thead>
                    <tbody>
                      {funcionarios.map((item, idx) => [item.nome+item.pis].filter(test => test.includes(`${pesquisar.toUpperCase()}`)).map(Nome => ( 
                        
                        <>
                          {showInativos ? (
                            <tr>
                              <td>{item.matricula.substring(9,15)}</td>
                              <td>{item.pis}</td>
                              <td>{item.nome}</td>
                              <td>{item.Nome}</td>
                              <td>{item.setor}</td>
                              {/*<td>{item.cargo}</td>*/}
                              <td>
                                {item.ativo === true ? (
                                  <div className="form-check ">
                                    <label className="form-check-label text-muted">
                                      <input
                                        checked={true}
                                        type="checkbox"
                                        className="form-check-input"
                                      />
                                      <i className="input-helper"></i>
                                    </label>
                                  </div>
                                ) : (
                                  <div className="form-check ">
                                    <label className="form-check-label text-muted">
                                      <input
                                        checked={false}
                                        type="checkbox"
                                        className="form-check-input"
                                      />
                                      <i className="input-helper"></i>
                                    </label>
                                  </div>
                                )}
                              </td>
                              <td>
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="btn btn-primary"
                                    id="dropdownMenuButton1"
                                  >
                                    Ação
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() =>
                                        history.push(
                                          `/dashboard/cadastro/funcionario/editar/${item.idPessoa}`
                                        )
                                      }
                                    >
                                      Alterar
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => handleModal(item.idPessoa)}
                                    >
                                      Excluir
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          ) : item.ativo ? (
                            <tr>
                              <td>{item.matricula.substring(9,15)}</td>
                              <td>{item.pis}</td>
                              <td>{item.nome}</td>
                              <td>{item.Nome}</td>
                              <td>{item.setor}</td>
                              {/*<td>{item.cargo}</td>*/}
                              <td>
                                {item.ativo === true ? (
                                  <div className="form-check ">
                                    <label className="form-check-label text-muted">
                                      <input
                                        checked={true}
                                        type="checkbox"
                                        className="form-check-input"
                                      />
                                      <i className="input-helper"></i>
                                    </label>
                                  </div>
                                ) : (
                                  <div className="form-check ">
                                    <label className="form-check-label text-muted">
                                      <input
                                        checked={false}
                                        type="checkbox"
                                        className="form-check-input"
                                      />
                                      <i className="input-helper"></i>
                                    </label>
                                  </div>
                                )}
                              </td>
                              <td>
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="btn btn-primary"
                                    id="dropdownMenuButton1"
                                  >
                                    Ação
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() =>
                                        history.push(
                                          `/dashboard/cadastro/funcionario/editar/${item.idPessoa}`
                                        )
                                      }
                                    >
                                      Alterar
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => handleModal(item.idPessoa)}
                                    >
                                      Excluir
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          ) : null}
                        </>
                      )))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <h4 className="card-title">Nenhum registro de funcionarios</h4>
              )}
            </div>
          </div>
        </div>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header>
            <Modal.Title>Atenção</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Tem certeza que deseja apagar esse funcionário?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleApagarFuncionario}>
              Sim
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  idEmpresa: state.data.idEmpresa,
});

export default connect(mapStateToProps)(Funcionarios);
